/**
 * Event V2 Repository - GraphQL Queries
 *
 * 7 query operations for Event primitive data access.
 */

import { gql } from '@apollo/client';
import { EVENT_FIELDS_FRAGMENT } from './fragments';

export const GET_EVENT = gql`
  ${EVENT_FIELDS_FRAGMENT}
  query GetEvent($tenantId: String!, $eventId: String!) {
    getEvent(tenantId: $tenantId, eventId: $eventId) {
      ...EventFields
    }
  }
`;

export const LIST_EVENTS = gql`
  ${EVENT_FIELDS_FRAGMENT}
  query ListEvents(
    $tenantId: String!
    $filter: EventFilterInput
    $limit: Int
    $cursor: String
  ) {
    listEvents(tenantId: $tenantId, filter: $filter, limit: $limit, cursor: $cursor) {
      items {
        ...EventFields
      }
      total
      nextCursor
      hasMore
    }
  }
`;

export const GET_EVENTS_BY_ENTITY = gql`
  ${EVENT_FIELDS_FRAGMENT}
  query GetEventsByEntity($tenantId: String!, $entityType: String!, $entityId: String!) {
    getEventsByEntity(tenantId: $tenantId, entityType: $entityType, entityId: $entityId) {
      ...EventFields
    }
  }
`;

export const GET_EVENTS_BY_WORKFLOW_INSTANCE = gql`
  ${EVENT_FIELDS_FRAGMENT}
  query GetEventsByWorkflowInstance($tenantId: String!, $workflowInstanceId: String!) {
    getEventsByWorkflowInstance(tenantId: $tenantId, workflowInstanceId: $workflowInstanceId) {
      ...EventFields
    }
  }
`;

export const GET_EVENTS_BY_TRANSACTION = gql`
  ${EVENT_FIELDS_FRAGMENT}
  query GetEventsByTransaction($tenantId: String!, $transactionId: String!) {
    getEventsByTransaction(tenantId: $tenantId, transactionId: $transactionId) {
      ...EventFields
    }
  }
`;

export const GET_CRITICAL_EVENTS = gql`
  ${EVENT_FIELDS_FRAGMENT}
  query GetCriticalEvents($tenantId: String!, $limit: Int) {
    getCriticalEvents(tenantId: $tenantId, limit: $limit) {
      ...EventFields
    }
  }
`;

export const VERIFY_EVENT_CHAIN_INTEGRITY = gql`
  query VerifyEventChainIntegrity($tenantId: String!, $workflowInstanceId: String!) {
    verifyEventChainIntegrity(tenantId: $tenantId, workflowInstanceId: $workflowInstanceId) {
      chainValid
      totalEvents
      invalidEvents
      lastVerifiedAt
    }
  }
`;
